// src/containers/DoNotTrackPage/DoNotTrackPage.js

import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import {
  LayoutSingleColumn,
  LayoutWrapperTopbar,
  LayoutWrapperMain,
  LayoutWrapperFooter,
} from '../../components';
import { StaticPage } from '../../containers';

import css from './DoNotTrackPage.css';
const DoNotTrackPage = () => {
  const history = useHistory();

  useEffect(() => {
    // This effect runs only once when the component mounts.
    try {
      // 1. Set the persistent flag in the browser's localStorage.
      localStorage.setItem('kindershare_user_role', 'internal');

      // 2. Alert the user to confirm the action was successful.
      alert(
        'Success! Your browser is now flagged for internal traffic filtering in Google Analytics.'
      );

      // 3. After a 2-second delay, redirect to the homepage.
      const timer = setTimeout(() => {
        history.push('/');
      }, 2000);

      // Clean up the timer if the component unmounts before the redirect happens.
      return () => clearTimeout(timer);
    } catch (e) {
      console.error('Failed to set localStorage item for internal tracking.', e);
      alert('An error occurred. Could not set the internal tracking flag. Please contact support.');
    }
  }, [history]); // The dependency array ensures this effect runs only once.

  return (
    <StaticPage
      title="Internal Traffic Filter Configuration"
      schema={{
        '@context': 'http://schema.org',
        '@type': 'WebPage',
        name: 'Internal Traffic Filter Configuration',
      }}
    >
      <LayoutSingleColumn>
        <LayoutWrapperTopbar />
        <LayoutWrapperMain>
          <div className={css.root}>
            <h1 className={css.title}>Configuring your browser...</h1>
            <p>Please wait, you will be redirected shortly.</p>
          </div>
        </LayoutWrapperMain>
        <LayoutWrapperFooter />
      </LayoutSingleColumn>
    </StaticPage>
  );
};

export default DoNotTrackPage;
